import { Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';

export const LoginInfoBoxSx: SystemStyleObject<Theme> = {
  marginTop: '24px',
  h1: {
    margin: 0,
    fontWeight: 700,
    fontSize: '14px',
    color: 'var(--dk-text, black)',
  },
  'table.companyCode': {
    marginTop: '16px',
    borderTop: '1px solid var(--dk-line-strong, black)',
    borderBottom: '1px solid var(--dk-line-strong, black)',
    thead: {
      borderBottom: '1px solid var(--dk-line-strong, black)',
      th: { padding: '8px 4px' },
    },
    tbody: {
      tr: {
        borderTop: '1px solid var(--dk-line, #E7E9EC)',
        '&:first-of-type': { borderColor: 'var(--dk-line-strong, black)' },
      },
      td: {
        padding: '12px 4px',
        border: 'none',
        fontSize: '14px',
        '&:first-of-type': { color: 'var(--dk-text-secondary, #888D96)' },
      },
    },
  },
};
